import { setTerms } from './helpers';

export const setEstateType = setTerms('estate_type');
